import { Link } from 'react-router-dom';
import { PrimaryButton } from '../buttons/PrimaryButton';
import { SubtleButton } from '../buttons/SubtleButton';
import type { ReactNode } from 'react';

export interface ErrorStatusPageProps {
    code: string | number;
    title: string;
    description: string;
    homeLabel?: string;
    backLabel?: string;
    homeTo?: string;
    onRetry?: () => void;
    retryLabel?: string;
    extra?: ReactNode;
}

export function ErrorStatusPage({
    code,
    title,
    description,
    homeLabel = 'العودة للرئيسية',
    backLabel = 'الرجوع للخلف',
    homeTo = '/',
    onRetry,
    retryLabel = 'إعادة المحاولة',
    extra,
}: ErrorStatusPageProps) {
    return (
        <div
            dir="rtl"
            className="flex flex-col items-center justify-center min-h-[70vh] w-full text-center px-4 py-16 font-cairo"
        >
            <p className="text-7xl sm:text-8xl font-bold text-primery-blue-500 leading-none tracking-tight">
                {code}
            </p>
            <h1 className="mt-4 text-2xl sm:text-3xl font-bold text-primery-blue-900">{title}</h1>
            <p className="mt-3 max-w-md text-sm sm:text-base text-[#7F7F7F] leading-relaxed">{description}</p>
            {extra}
            <div className="mt-8 flex flex-col sm:flex-row items-center gap-3">
                {onRetry ? (
                    <PrimaryButton type="button" className="min-w-[160px]" onClick={onRetry}>
                        {retryLabel}
                    </PrimaryButton>
                ) : (
                    <Link to={homeTo}>
                        <PrimaryButton type="button" className="min-w-[160px]">
                            {homeLabel}
                        </PrimaryButton>
                    </Link>
                )}
                {onRetry ? (
                    <Link to={homeTo}>
                        <SubtleButton type="button" className="min-w-[160px]">
                            {homeLabel}
                        </SubtleButton>
                    </Link>
                ) : (
                    <SubtleButton
                        type="button"
                        className="min-w-[160px]"
                        onClick={() => window.history.back()}
                    >
                        {backLabel}
                    </SubtleButton>
                )}
            </div>
        </div>
    );
}

export default ErrorStatusPage;
